import {Flex} from 'antd';
import React from 'react';

import {formatIndian} from '../../../../utils/formatIndian';

export interface ScopeLegendItem {
  name: string;
  value: number;
  fill: string;
}

const ScopeLegend: React.FC<{
  items: ScopeLegendItem[];
  unit?: string;
}> = ({items = [], unit = 'tCO2e'}) => {
  const total = items.reduce((sum, item) => sum + (item.value ?? 0), 0);

  return (
    <Flex className="scopeLegend" align="stretch">
      {items.map((item, index) => {
        const percentage = total > 0 ? ((item.value ?? 0) / total) * 100 : 0;
        const displayPercentage = Number(percentage.toFixed(2));

        return (
          <div key={item.name ?? index} className="scopeLegendItem">
            <div className="scopeLegendHeader">
              <span
                className="scopeLegendDot"
                style={{backgroundColor: item.fill}}
              />
              <span className="scopeLegendName">{item.name}</span>
            </div>
            <span className="scopeLegendPill">{displayPercentage}%</span>
            <div className="scopeLegendValue">
              <span className="scopeLegendNumber">
                {formatIndian(item.value ?? 0)}
              </span>
              <span className="scopeLegendUnit"> {unit}</span>
            </div>
          </div>
        );
      })}
    </Flex>
  );
};

export default ScopeLegend;
